import { AxiosResponse } from 'axios'

import { getAppURL } from '@/shared/utils/electron'
import { FetchResponse, useFetchApi } from '@/shared/utils/fetch'

import { QueueService } from '../types'

const API_PATH = '/api/user/queue-services'

export const useQueueServiceApi = () => {
  const useFetch = useFetchApi()

  return {
    getQueueServices (): Promise<AxiosResponse<QueueService[]> | FetchResponse<QueueService[]>> {
      return useFetch.get(getAppURL({ pathName: API_PATH }))
    },
    patchQueueServices (
      queues: QueueService[],
    ): Promise<AxiosResponse<QueueService[]> | FetchResponse<QueueService[]>> {
      return useFetch.patch(getAppURL({ pathName: API_PATH }), queues)
    },
  }
}
